<template>
  <div class="inline-flex p-[0.3rem] bg-[#F1F1F1] rounded-lg">
    <button
      v-for="option in options"
      :key="option.value"
      :class="[
        'px-[0.625rem] py-[0.3rem] text-sm font-medium rounded-md transition-colors border-none outline-none focus:outline-none',
        value === option.value
          ? 'bg-white shadow-sm text-gray-900'
          : 'text-gray-500 hover:text-gray-700 hover:bg-gray-200/50'
      ]"
      @click="$emit('input', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'Tab',
  props: {
    value: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [
        { label: 'Dashboard', value: 'dashboard' },
        { label: 'Komchat AI', value: 'ai' },
      ],
    },
  },
}
</script>
